<template>
  <b-container>
    <b-row align-h="center" class="mt-5">
      <b-col cols="5">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Login</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">
          <b-card-text>Login with Steam</b-card-text>
          <a :href="steamLoginURL">
            <img src="@/assets/img/steam/login_button_1.png" />
          </a>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
 data() {
    return {
      steamLoginURL: process.env.API_URL + '/api/auth/steam',
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SteamLogin.vue